module.exports = __webpack_public_path__ + "img/flammable_materials.97b72020.svg";